import { Stack, Typography } from '@mui/material'

export const Cookie = (): JSX.Element => {
  return (
    <>
      <Typography variant="pageTitle">Cookie Policy</Typography>
      <div className="body padding-top-m padding-bottom-l" id="body">
        <div className="default-page" style={{ textAlign: 'left' }}>
          <Typography variant="subtitle1">
            Ai sensi dell’articolo 13 Regolamento EU 679/2016 (d’ora in poi
            “Regolamento”) e dei Provvedimenti del Garante Privacy, Bludata
            S.r.l. fornisce le seguenti informazioni relative ai cookie
            installati su questo sito.
          </Typography>
          <Typography variant="h6" sx={{ p: '10px 0 5px' }}>
            Cosa sono i cookie?
          </Typography>
          <Typography variant="subtitle1">
            I cookie sono stringhe di testo che i siti web visitati dall’utente
            posizionano e archiviano all’interno del dispositivo (computer,
            smartphone, tablet), per essere poi ritrasmessi agli stessi siti
            alla visita successiva.
          </Typography>
          <Typography variant="subtitle1">
            I cookie si distinguono per durata e per origine. Quanto alla
            durata, sono persistenti se rimangono memorizzati per un periodo
            prestabilito, oppure di sessione se vengono eliminati alla chiusura
            del browser. Quanto all’origine, sono di prima parte se installati
            dal sito visitato, di terza parte se provenienti da domini esterni.
          </Typography>
          <Typography variant="h6" sx={{ p: '10px 0 5px' }}>
            Questo sito come utilizza i cookie?
          </Typography>
          <Typography variant="subtitle1">
            Questo sito utilizza esclusivamente cookie tecnici persistenti di
            prima parte, necessari al corretto funzionamento del servizio. I
            cookie tecnici non richiedono il consenso preventivo dell’utente
            (art. 6, par. 1, lett. f del Regolamento UE 2016/679: legittimo
            interesse del Titolare).
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, textDecoration: 'underline', pt: '5px' }}
          >
            Cookie tecnici di prima parte che non richiedono il consenso
            preventivo dell’utente:
          </Typography>
          <div style={{ padding: '10px 0' }}>
            <Stack
              direction="row"
              sx={{
                flex: "1",
                justifyContent: "space-between",
                gap: 2
              }}>
              <Stack direction="column" sx={{
                flex: "2"
              }}>
                <Typography variant="subtitle1" sx={{
                  fontWeight: "500"
                }}>
                  Nome cookie
                </Typography>
                <Typography variant="subtitle1">
                  appointment_banner_cookie
                </Typography>
              </Stack>
              <Stack direction="column" sx={{
                flex: "3"
              }}>
                <Typography variant="subtitle1" sx={{
                  fontWeight: "500"
                }}>
                  Finalità
                </Typography>
                <Typography variant="subtitle1">
                  Memorizza la preferenza dell’utente sul banner cookie,
                  evitando che venga mostrato ad ogni visita.
                </Typography>
              </Stack>
              <Stack direction="column" sx={{
                flex: "2"
              }}>
                <Typography variant="subtitle1" sx={{
                  fontWeight: "500"
                }}>
                  Tipo
                </Typography>
                <Typography variant="subtitle1">
                  Tecnico — persistente
                </Typography>
              </Stack>
              <Stack direction="column" sx={{
                flex: "1"
              }}>
                <Typography variant="subtitle1" sx={{
                  fontWeight: "500"
                }}>
                  Durata
                </Typography>
                <Typography variant="subtitle1">12 mesi</Typography>
              </Stack>
              <Stack direction="column" sx={{
                flex: "1"
              }}>
                <Typography variant="subtitle1" sx={{
                  fontWeight: "500"
                }}>
                  Parte
                </Typography>
                <Typography variant="subtitle1">Prima parte</Typography>
              </Stack>
            </Stack>
          </div>
          <Typography variant="subtitle1">
            L’utente può cancellare il cookie in qualsiasi momento tramite le
            impostazioni del proprio browser alla voce “Cookie” o “Dati di
            navigazione”. La cancellazione del cookie comporterà la ricomparsa
            del banner alla visita successiva.
          </Typography>
          <Typography variant="h6" sx={{ p: '10px 0 5px' }}>
            Titolare del trattamento e Responsabile della Protezione dei Dati
          </Typography>
          <Typography variant="subtitle1">
            Bludata S.r.l., con sede in Via delle Industrie, 10 — 31030 Breda di
            Piave (Treviso). Tel. 0422 445442, e-mail: info@bludata.com, PEC:
            bludata@legalmail.it. Il Responsabile della Protezione dei Dati
            (RPD) è raggiungibile ai recapiti del Titolare e al seguente
            indirizzo email: dpo@bludata.com.
          </Typography>
          <Typography variant="h6" sx={{ p: '10px 0 5px' }}>
            Diritti degli interessati
          </Typography>
          <Typography variant="subtitle1">
            La normativa a protezione dei dati personali prevede espressamente
            alcuni diritti in capo ai soggetti cui dati si riferiscono (c.d.
            interessato). In particolare, ai sensi degli articoli 15–22 del
            Regolamento (UE) 2016/679, ciascun interessato ha il diritto di
            ottenere la conferma dell’esistenza o meno dei medesimi dati e di
            conoscerne il contenuto e l’origine, verificarne l’esattezza o
            chiederne l’integrazione o l’aggiornamento, oppure la rettificazione.
            Ai sensi dei medesimi articoli, l’interessato ha il diritto di
            chiedere la cancellazione, la limitazione, la portabilità dei dati,
            nonché di opporsi, per motivi legittimi, al trattamento dei dati.
          </Typography>
          <Typography variant="subtitle1">
            Inoltre, ai sensi dell’art. 77 del Regolamento, qualora
            l’interessato ritenga che il trattamento che lo riguarda violi il
            Regolamento, ha il diritto di proporre reclamo al Garante per la
            protezione dei dati personali. Per l’esercizio di tali diritti,
            l’interessato può rivolgersi al Titolare scrivendo a Bludata S.r.l.,
            Via delle Industrie, 10 — 31030 Breda di Piave (Treviso), e-mail:
            privacy@bludata.com, PEC: bludata@legalmail.it. Il Responsabile
            della Protezione dei Dati (RPD) è raggiungibile al seguente
            indirizzo email: dpo@bludata.com.
          </Typography>
          <Typography variant="subtitle1">
            Data ultima revisione: 07/04/2026
          </Typography>
        </div>
      </div>
    </>
  );
}
